import { isEmpty } from 'lodash';
import { Dispatch } from 'react';
import { apiBaseUrl, networkCall } from '../../utils/networkCall';
import { ApiMap, Instances } from '../../constants';
import { mapInstanceWithWAChannel } from '../../pages/channels/Whatsapp/containers/logs';

export const GET_DATA: string = "GET_DATA";
export const VOICE_GET_DATA: string = "VOICE_GET_DATA";

export const voiceInstance: Array<string> = ['voiceLogsV1','voiceLogsV2'];

export const getData = (logsFor: string, wabaID?: string|number) => {

    let baseUrl = apiBaseUrl.baseUrl;

    if (logsFor.includes('V2') && !voiceInstance.includes(logsFor)) {
        baseUrl = apiBaseUrl.baseUrlV2;
    }

    return (dispatch: Dispatch<any>) => {
        networkCall("get", ApiMap[`${mapInstanceWithWAChannel[logsFor]}`] , baseUrl, true, true, { wabaID: wabaID })
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    if(voiceInstance.includes(logsFor)){
                        dispatch({ type: VOICE_GET_DATA, payload: res });
                    }else{
                        dispatch({ type: GET_DATA, payload: res });
                    }
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    console.log(error.response)
                }
            });
    }
}

